import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { key: String };

  show(event) {
    event.preventDefault();
    const key = this.keyValue;

    document.querySelectorAll("[data-nav-tab-panel]").forEach((panel) => {
      if (panel.dataset.navTabPanel === key) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });

    document.querySelectorAll("[data-nav-tab]").forEach((el) => {
      const cls = el.dataset.navActiveClass;
      if (!cls) return;
      const active = el.dataset.navTab === key;
      cls.split(" ").forEach((c) => {
        if (active) el.classList.add(c);
        else el.classList.remove(c);
      });
    });
  }
}
